import { useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { BannerQuorum } from './BannerQuorum.js';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';
import { useSessao } from '../auth/SessaoContexto.js';

/**
 * Casca do painel: sidebar fixa, topbar e a área de conteúdo com rolagem.
 *
 * A responsividade não existia no handoff — foi explicitamente deixada para a
 * fase de código. Abaixo de 1024px a sidebar vira gaveta.
 */

/** Título e subtítulo por rota, como no protótipo. */
const TITULOS: Record<string, [string, string]> = {
  '/': ['Dashboard', 'Visão geral do gerenciamento de DNS reverso'],
  '/ips': ['Gerenciar IPs', 'Todos os endereços, PTR, cliente e status'],
  '/operadoras': ['Operadoras', 'Clientes e provedores gerenciados'],
  '/blocos': ['Blocos de IP', 'Prefixos CIDR IPv4 e IPv6'],
  '/zonas': ['Zonas Reverse', 'in-addr.arpa e ip6.arpa'],
  '/ptr': ['Registros PTR', 'Editor de reversos do bloco'],
  '/solicitacoes': ['Solicitações', 'Alterações de PTR aguardando aprovação'],
  '/templates': ['Templates PTR', 'Padrões de nomenclatura reutilizáveis'],
  '/servidores': ['Servidores', 'Nós do cluster e status do PowerDNS'],
  '/sincronizacao': ['Sincronização', 'Diff entre o painel e o PowerDNS'],
  '/tokens': ['API Tokens', 'Chaves de acesso para integrações externas'],
  '/dominios': ['Domínios', 'Zonas autoritativas dos domínios dos clientes'],
  '/configuracoes': ['Configurações', 'Servidor de e-mail e ajustes do sistema'],
  '/logs': ['Logs & Auditoria', 'Histórico de todas as alterações'],
  '/usuarios': ['Usuários & Acesso', 'Papéis e escopos de permissão'],
  '/perfil': ['Meu perfil', 'Dados da conta, segurança e notificações'],
};

export function Shell() {
  const [menuAberto, setMenuAberto] = useState(false);
  const { pathname } = useLocation();
  const { usuario } = useSessao();

  // Cai para o segmento raiz: /blocos/abc-123/ptr usa o título de /blocos.
  const chave = TITULOS[pathname] ? pathname : `/${pathname.split('/')[1] ?? ''}`;
  const [titulo, subtitulo] = TITULOS[chave] ?? ['rDNS Manager', ''];

  return (
    <div className="min-h-dvh">
      <Sidebar
        aberta={menuAberto}
        aoFechar={() => setMenuAberto(false)}
        usuario={usuario ? { nome: usuario.nome, email: usuario.email } : undefined}
      />

      <div className="lg:pl-sidebar">
        <Topbar
          titulo={titulo}
          subtitulo={subtitulo}
          aoAbrirMenu={() => setMenuAberto(true)}
        />
        <BannerQuorum />

        <main className="p-4 lg:p-[26px]">
          {/* max-width centralizado, como no handoff: tabela de IP fica
              ilegível quando a linha atravessa um monitor ultrawide. */}
          <div className="mx-auto max-w-[1440px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
